import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Routes, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { MsalGuard } from '@azure/msal-angular';
import { Select } from '@ngxs/store';

import { ItToolsUsageComponent } from './pages/kpi-data-mgmt/it-tools-usage/it-tools-usage.component';
import { DrivingBehaviorComponent } from './pages/kpi-data-mgmt/driving-behavior/driving-behavior.component';
import { PageRoutePath } from '@shared/constants';
import { EconomyComponent } from './pages/kpi-data-mgmt/economy/economy.component';
import { DriverDataComponent } from './pages/driver-data/driver-data.component';
import { OthersComponent } from './pages/kpi-data-mgmt/others/others.component';
import { CoachingComponent } from './pages/coaching/coaching.component';
import { SafetyComponent } from './pages/kpi-data-mgmt/safety/safety.component';
import { AchievementComponent } from './pages/achievement/achievement.component';
import { ReportLinkComponent } from './pages/report-link/report-link.component';
import { OrgUnitComponent } from './pages/org-unit/org-unit.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { TeamMessageComponent } from './pages/team-message/team-message.component';
import { KpiConfigurationComponent } from './pages/kpi-configuration/kpi-configuration.component';
import { SetApexIdComponent } from './pages/set-apex-id/set-apex-id.component';
import { AwardComponent } from './pages/award/award.component';
import { SupervisorControlPanelComponent } from './pages/supervisor-control-panel/supervisor-control-panel.component';
import { SideNavigationComponent } from '@app/side-navigation/side-navigation.component';
import { HomeComponent } from '@app/pages/home/home.component';
import { SupervisorDashboardComponent } from './pages/supervisor-dashboard/supervisor-dashboard.component';
import { CommonDataState } from './shared/stores/common-data.state';
import { UserProfile } from './shared/classes/user-profile';
import { DMPRole } from './shared/enums';
import { BatchImportExcelComponent } from './pages/batch-import-excel/batch-import-excel.component';
import { ExternalReportComponent } from './pages/external-report/external-report.component';
import { PowerAppComponent } from './pages/power-app/power-app.component';

@Injectable({
  providedIn: 'root'
})
export class DMPRoleGuard implements CanActivate {
  @Select(CommonDataState.profileMe) profileMe$: Observable<UserProfile>;

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.profileMe$.pipe(map(profileMe => profileMe?.role_id !== DMPRole.SUPERVISOR));
  }
}

export const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [MsalGuard] },
  { path: PageRoutePath.HOME, component: HomeComponent, canActivate: [MsalGuard] },
  { path: PageRoutePath.NAVIGATION, component: SideNavigationComponent, canActivate: [MsalGuard] },
  { path: PageRoutePath.SET_APEX_ID, component: SetApexIdComponent, canActivate: [MsalGuard] },
  { path: PageRoutePath.SUPERVISOR_CONTROL_PANEL, component: SupervisorControlPanelComponent, canActivate: [MsalGuard] },
  { path: PageRoutePath.DRIVER_DATA, component: DriverDataComponent, canActivate: [MsalGuard, DMPRoleGuard] },
  { path: PageRoutePath.ORG_UNIT, component: OrgUnitComponent, canActivate: [MsalGuard, DMPRoleGuard] },
  { path: PageRoutePath.KPI_WEIGHT, component: KpiConfigurationComponent, canActivate: [MsalGuard, DMPRoleGuard] },
  { path: PageRoutePath.USER_PROFILE, component: UserProfileComponent, canActivate: [MsalGuard, DMPRoleGuard] },
  { path: PageRoutePath.KPI_DRIVING_BEHAVIOR, component: DrivingBehaviorComponent, canActivate: [MsalGuard, DMPRoleGuard] },
  { path: PageRoutePath.KPI_IT_TOOLS_USAGE, component: ItToolsUsageComponent, canActivate: [MsalGuard, DMPRoleGuard] },
  { path: PageRoutePath.KPI_SAFETY, component: SafetyComponent, canActivate: [MsalGuard, DMPRoleGuard] },
  { path: PageRoutePath.KPI_ECONOMY, component: EconomyComponent, canActivate: [MsalGuard, DMPRoleGuard] },
  { path: PageRoutePath.KPI_OTHERS, component: OthersComponent, canActivate: [MsalGuard] },
  { path: PageRoutePath.COACHING, component: CoachingComponent, canActivate: [MsalGuard] },
  { path: PageRoutePath.ACHIEVEMENT, component: AchievementComponent, canActivate: [MsalGuard, DMPRoleGuard] },
  { path: PageRoutePath.AWARD, component: AwardComponent, canActivate: [MsalGuard, DMPRoleGuard] },
  { path: PageRoutePath.REPORT_LINK, component: ReportLinkComponent, canActivate: [MsalGuard, DMPRoleGuard] },
  { path: PageRoutePath.TEAM_MESSAGE, component: TeamMessageComponent, canActivate: [MsalGuard] },
  { path: PageRoutePath.SUPERVISOR_DASHBOARD + '/:id', component: SupervisorDashboardComponent, canActivate: [MsalGuard] },  
  { path: PageRoutePath.EXTERNAL_REPORT, component: ExternalReportComponent, canActivate: [MsalGuard] },
  { path: PageRoutePath.BATCH_IMPORT_EXCEL, component: BatchImportExcelComponent, canActivate: [MsalGuard] },
  { path: PageRoutePath.POWER_APP, component: PowerAppComponent, canActivate: [MsalGuard] }
  // { path: '**', redirectTo: '', pathMatch: 'full' }
];

